<div
  class="demand-reasons-list"
  *ngIf="customer$ | async">
  <mat-card class="mat-elevation-z2">
    <mat-card-title> </mat-card-title>
    <mat-card-content>
      <div
        class="row"
        *ngFor="let cancelReason of cancelReasons$ | async; trackBy: trackById">
        <div class="col">
          <div class="cancel-reason-row">
            <div class="cancel-reason-details">
              <mat-form-field>
                <mat-label>{{
                  ("title" | i18n) || "Titel" | titlecase
                }}</mat-label>
                <input
                  *ngIf="(customer$ | async)?.locale ?? 'de' as locale"
                  matInput
                  required
                  [(ngModel)]="cancelReason.displayName[locale]"
                  [name]="'displayName-' + cancelReason.id" />
              </mat-form-field>
              <mat-slide-toggle
                class="cancel-reason-description-toggle"
                [(ngModel)]="cancelReason.enableDescription">
                <span>{{
                  ("enableDescription" | i18n) || "Beschreibungstext"
                    | titlecase
                }}</span>
              </mat-slide-toggle>
              <mat-form-field class="cancel-reason-availability-select">
                <mat-label>
                  {{
                    ("availabilityStatus" | i18n) ||
                      "Pooler Verfügbarkeit nach Storno" | titlecase
                  }}
                </mat-label>
                <mat-select [(ngModel)]="cancelReason.statusAfterCancel">
                  <mat-option
                    *ngFor="
                      let status of availableStatuses$ | async | keysToArray
                    "
                    [value]="status">
                    {{ ("statusAfterCancel." + status | i18n) || status }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="cancel-reason-buttons">
              <button
                class="cancel-reason-button"
                mat-button
                type="button"
                (click)="cancelChanges(cancelReason.id)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="cancel-reason-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="cancel-reason-button save-button"
                mat-button
                type="button"
                (click)="saveCancelReason(cancelReason.id)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="cancel-reason-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
              <button
                class="cancel-reason-button delete-button"
                mat-button
                type="button"
                (click)="deleteCancelReason(cancelReason.id)"
                [matTooltip]="('remove' | i18n) || 'Löschen' | titlecase">
                <mat-icon
                  class="cancel-reason-button-icon"
                  svgIcon="delete-trash-remove"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngFor="
          let cancelReason of cancelReasonsInCreation$ | async;
          let i = index
        ">
        <div class="col">
          <div class="cancel-reason-row">
            <div class="cancel-reason-details">
              <mat-form-field>
                <mat-label>{{
                  ("title" | i18n) || "Titel" | titlecase
                }}</mat-label>
                <input
                  *ngIf="(customer$ | async)?.locale ?? 'de' as locale"
                  matInput
                  required
                  [(ngModel)]="cancelReason.displayName[locale]"
                  [name]="'newDisplayName-' + i" />
              </mat-form-field>
              <mat-slide-toggle
                class="cancel-reason-description-toggle"
                [(ngModel)]="cancelReason.enableDescription">
                <span>{{
                  ("enableDescription" | i18n) || "Beschreibungstext"
                    | titlecase
                }}</span>
              </mat-slide-toggle>
              <mat-form-field class="cancel-reason-availability-select">
                <mat-label>
                  {{
                    ("availabilityStatus" | i18n) ||
                      "Pooler Verfügbarkeit nach Storno" | titlecase
                  }}
                </mat-label>
                <mat-select [(ngModel)]="cancelReason.statusAfterCancel">
                  <mat-option
                    *ngFor="
                      let status of availableStatuses$ | async | keysToArray
                    "
                    [value]="status">
                    {{ ("statusAfterCancel." + status | i18n) || status }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="cancel-reason-buttons">
              <button
                class="cancel-reason-button"
                mat-button
                type="button"
                (click)="cancelNewCancelReason(i)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="cancel-reason-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="cancel-reason-button save-button"
                mat-button
                type="button"
                (click)="saveNewCancelReason(i)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="cancel-reason-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <button
            class="outline-pill-button icon-left"
            type="button"
            data-cy="add-cancel-reason-button"
            (click)="addNewCancelReason()">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{
              ("addCancelReason" | i18n) || "Storniergrund hinzufügen"
                | titlecase
            }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
